import React from "react";
import Button from "../ui/Button/Button";
import styles from "./SignatureBillet.module.sass";
import api from "../../utils/api";
import gaTags from "../../utils/ga-tags";

const SignatureBillet = (props) => {
  const downloadHandler = (filename, endpoint) => {
    api
      .get(
        endpoint,
        { codigo: props.proposta },
        {
          codigoUsuario: api.CODIGO_USUARIO(),
          cotacao: props.cotationCode,
          cpfcnpj: props.document,
        },
        { responseType: "blob" }
      )
      .then((result) => {
        const blob = result.data;
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      });
  };

  const gaTypeName = `${gaTags.typeFlow2.concat("5-")}&CheckOut-Sucesso`;
  return (
    <div className={styles.content}>
      <p>Toque no botão abaixo para gerar o seu.</p>
      <div className={styles.buttonsList}>
        {props.bb && (
          <Button
            className={styles.buttonItem}
            onClick={() =>
              downloadHandler("boleto.pdf", api.endpoints.DOWNLOAD_BOLETO)
            }
            data-gacategory={gaTags.categoryFlow}
            data-gatype={gaTypeName}
            data-gafunc={`${gaTypeName}-Boleto`}
          >
            <i className="icon icon-download" />
            Boleto
          </Button>
        )}
      </div>
    </div>
  );
};

export default SignatureBillet;
